module.exports = __webpack_public_path__ + "img/bdcb7e6.png";